// @ts-nocheck
import { searchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import searchResultProps from "@store/Themes/common/props/searchResults";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(searchHistoryStyles, {
    headerText: searchResultProps.title,
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: ${pxToRem(0, 20, 15)};
        `,
    },
    link: searchResultProps.link,
    focusedLink: searchResultProps.focusedLink,
    clearLink: {
        typographyProps: {
            css: css`
                margin-top: ${pxToRem(10)};
            `,
        },
    },
});
